import { Drawer } from '@loop/ui'
import { Box, Typography } from '@mui/material'
import get from 'lodash/get'
import { useState } from 'react'
import BackArrowBtnComp from 'src/components/OrderDrawer/components/BackArrowBtnComp'
import { DelIntelThemeGroupby } from 'src/services/openApiV2'
import ErrorInsightsThemeSummary from './ErrorInsightsThemeSummary'
import ErrorInsightsThemeTable from './ErrorInsightsThemeTable'

export enum ProblematicType {
  LOCATION = 'location',
  ITEM = 'item',
  THEME = 'theme'
}

interface ErrorInsightsThemeDrawerProps {
  errorTheme: DelIntelThemeGroupby
  onClose: () => void
}

const ErrorInsightsThemeDrawer = ({ errorTheme, onClose }: ErrorInsightsThemeDrawerProps) => {
  const [activeProblematic, setActiveProblematic] = useState<{
    type: ProblematicType
    name: string
  }>(null)

  const handleClose = () => {
    setActiveProblematic(null)
    onClose()
  }

  return (
    <Drawer
      open={!!errorTheme}
      onClose={handleClose}>
      <Box
        minWidth="300px"
        width="80vw"
        px={3}
        py={3}>
        <Box
          display="flex"
          alignItems="center"
          gap={2}
          mb={4}>
          <BackArrowBtnComp onClick={handleClose} />

          <Typography
            fontSize={20}
            fontWeight={600}>
            {get(errorTheme, 'theme', '')}
          </Typography>
        </Box>

        <Box
          display="flex"
          flexDirection="column"
          gap={3}>
          <ErrorInsightsThemeSummary
            errorTheme={errorTheme}
            activeProblematic={activeProblematic}
            onProblematicClick={(type, name) => {
              if (type === activeProblematic?.type && name === activeProblematic?.name) {
                setActiveProblematic(null)
              } else {
                setActiveProblematic({ type, name })
              }
            }}
          />
          <ErrorInsightsThemeTable
            errorTheme={errorTheme}
            activeProblematic={activeProblematic}
          />
        </Box>
      </Box>
    </Drawer>
  )
}

export default ErrorInsightsThemeDrawer
